import React from 'react';
import { motion } from 'framer-motion';
import { Flame, Target, Zap, Moon, Brain, Shield } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    icon: <Flame size={32} className="text-[#E8441A]" data-id="element-10" />,
    title: 'Ignites Your Metabolism',
    description: "Reactivates your body's natural fat-burning furnace"
  }, {
    icon: <Target size={32} className="text-[#E8441A]" data-id="element-11" />,
    title: 'Targets Stubborn Belly Fat',
    description: 'Specially formulated thermogenic blend attacks belly fat first'
  }, {
    icon: <Zap size={32} className="text-[#E8441A]" data-id="element-12" />,
    title: 'Boosts Your Energy',
    description: 'Feel energized and active throughout the day'
  }, {
    icon: <Moon size={32} className="text-[#E8441A]" data-id="element-13" />,
    title: 'Improves Sleep Quality',
    description: 'Better sleep means better fat burning overnight'
  }, {
    icon: <Brain size={32} className="text-[#E8441A]" data-id="element-14" />,
    title: 'Reduces Food Cravings',
    description: 'Stop fighting hunger and take control'
  }, {
    icon: <Shield size={32} className="text-[#E8441A]" data-id="element-15" />,
    title: 'Extra Strength Formula',
    description: '30 powerful capsules per bottle'
  }];
  return <section className="py-16 lg:py-24 bg-white" data-id="element-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-17">
        <div className="text-center mb-16" data-id="element-18">
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900" data-id="element-19">
            What CitrusBurn™ Does For You
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-20">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-8 border border-slate-100 shadow-lg hover:shadow-xl transition-shadow duration-300" data-id="element-21">
              <div className="w-16 h-16 bg-[#FFF5F0] rounded-2xl flex items-center justify-center mb-6" data-id="element-22">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-23">
                {benefit.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-24">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}